'use strict';

var _ = require('lodash');
var ListActionsToolbarDirective = function ListActionsToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'ListActionsToolbarController',
    template: require('../templates/list-actions-toolbar.html'),
    scope: {
      elementService: '=',
      allowEmptyCollection: '=?',
      addButtonVisible: '=?',
      clearFirstElement: '=?'
    },
    link: function link(scope) {
      scope.allowEmptyCollection = scope.allowEmptyCollection || false;
      scope.addButtonVisible = _.isUndefined(scope.addButtonVisible) ? true : scope.addButtonVisible;
    }
  };
};
ListActionsToolbarDirective.$inject = [];
module.exports = ListActionsToolbarDirective;